import { createRequest } from "helpers/tools";

export const createTrackerEventsAsync = async (event) => {
  return await createRequest({
    suffix: "events",
    method: "post",
    payload: event,
    handleError: false,
  });
};
